import React, { ReactElement } from "react";
import { Box, Heading, Text } from "rebass";

interface IProps {
  eyebrow?: string | undefined;
  title: string;
  subheading?: string | undefined;
  desc?: string | undefined;
  info?: ReactElement | null;
}

const Card = (props: IProps) => {
  return (
    <Box width={[1/1, 1/2, 4/12]} p={[4,5]} mr={[2,3]} mb={[2,3]}
      sx={{ borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "borderColorQuiet", 
      borderRadius: "2rem",
    }}>
     
      <Heading as="h2" variant="bigTitleXS">{props.title}</Heading>
      <Heading as="h3" variant="catHeading">{props.eyebrow}</Heading>
      <Text as="p" variant="paragraphXL"><strong>{props.subheading}</strong></Text>
      <Text as="p" mb={[2,3,4]}>{props.desc}</Text>
      <Heading as="h3" variant="catHeading">user mindset</Heading>
      <Box>{props.info}</Box>
    </Box>  
  )
}

export default Card;

